import React from 'react';

import advancedTimingDetection from '../../../main/assets/images/lapRf/advanced-timing-detection.webp';

export const AdvancedTimingDetection = () => {
  return (
    <section className="laprf-advanced-timing">
      <img
        src={advancedTimingDetection}
        alt="Representation of Race Timing Precision"
        className="laprf-advanced-timing-product"
      />
      <div className="laprf-advanced-timing-text">
        <h2 className="laprf-advanced-timing-title">
          Precision Without compromise
        </h2>
        <p className="laprf-advanced-timing-description">
          Engineered for high-stakes competition, the LapRF 8-Way delivers clean
          signal detection, real-time responsiveness, and stable video - so
          pilots stay focused on flying, not on failure. It’s the timing system
          that keeps up when every millisecond counts.
        </p>
      </div>
    </section>
  );
};
